import React from "react";

import "./assets/css/style.css";

function BlockOnMobileOverlay() {
  return (
    <div id="blockOnMobile">
      <p>For best viewing of this content, please access using a personal computer device.</p>
    </div>
  );
}

export default BlockOnMobileOverlay;
